/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
    <form @submit.prevent="handleLogin" class="auth-form">
        <label>Correo</label>
        <input 
            type="email" 
            placeholder="Ingresa tu correo" 
            v-model="email" 
            :class="{ 'input-error': errors.email || errors.general }"
            @input="limpiarErrores"
            required 
        />

        <label>Contraseña</label>
        <div class="password-wrapper">
            <input 
                :type="showPassword ? 'text' : 'password'" 
                placeholder=" ● ● ● ● ● ● ● ● " 
                v-model="password"
                :class="{ 'input-error': errors.password || errors.general }" 
                @input="limpiarErrores"
                required 
            />
            <i class="fa-solid toggle-icon" :class="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                @click="showPassword = !showPassword"></i>
        </div>

        <div v-if="errors.general" class="error-message">
            {{ errors.general }}
        </div>

        <div class="links-group">
            <div class="link" @click="$emit('change-view', 'recovery')">Olvidé mi contraseña</div>
            <div class="link-secondary" @click="$emit('change-view', 'register')">Crear cuenta</div>
        </div>

        <button type="submit" :disabled="isLoading">
            {{ isLoading ? 'Iniciando...' : 'Iniciar sesión' }}
        </button>

        <div v-if="isLoading" class="loader-overlay">
            <div class="loader-spinner"></div>
            <p>Iniciando sesión...</p>
        </div>

        <CambiarContrasena v-if="mostrarModalCambioContrasena" @cerrarModal="mostrarModalCambioContrasena = false" />
    </form>
</template>

<script>
import AuthService from '@/services/authService';
import CambiarContrasena from '@/components/auth/RecuperarContraseña.vue';

export default {
    name: 'LoginForm',
    components: { CambiarContrasena },
    data() {
        return {
            email: '',
            password: '',
            errors: { 
                general: '',
                email: false,
                password: false 
            },
            isLoading: false,
            mostrarModalCambioContrasena: false,
            showPassword: false,
        };
    },
    methods: {
        limpiarErrores() {
            this.errors.general = '';
            this.errors.email = false;
            this.errors.password = false;
        },
        async handleLogin() {
            this.limpiarErrores();
            this.isLoading = true;

            const emailNormalizado = this.email.toLowerCase().trim();

            try {
                const response = await AuthService.login(emailNormalizado, this.password);
                const usuario = response.data.usuario;

                if (usuario && usuario.id_usuario) {
                    localStorage.removeItem('nombreUsuario');
                    localStorage.removeItem('rolUsuario');
                    localStorage.removeItem('usuario');
                    
                    localStorage.setItem('userData', JSON.stringify(usuario));

                    if (usuario.temporal === 1) {
                        this.mostrarModalCambioContrasena = true;
                        this.isLoading = false; 
                    } else {
                        const targetRoute = usuario.rol?.nombre === 'Instalador' ? '/Bienvenida' : '/Bienvenida';
                        if (this.$router) {
                            await this.$router.replace(targetRoute);
                        }
                    }
                } else {
                    throw new Error("Credenciales inválidas");
                }
            } catch (error) {
                console.error("Error login:", error);
                this.errors.general = "Correo o contraseña incorrectos";
                this.errors.email = true;
                this.errors.password = true;
                this.isLoading = false; 
            }
        }
    }
};
</script>

<style scoped>
.auth-form {
    width: 80%;
    display: flex;
    flex-direction: column;
}

label {
    font-size: 20px;
    margin: 20px 0px 10px 0px;
}

input {
    width: 100%;
    height: 42px;
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .05);
    border-radius: 8px;
    padding: 0 10px;
    font-size: 14px;
    color: #333;
    outline: none;
    box-sizing: border-box;
    transition: all .3s ease;
}

input:focus {
    border-color: #29b9f6;
    box-shadow: 0 0 0 3px rgba(47, 141, 183, .2);
}

.input-error {
    border: 1px solid #e55050 !important;
    background-color: #fff9f9;
}

.password-wrapper {
    position: relative;
    width: 100%;
}

.password-wrapper input {
    padding-right: 45px;
}

.toggle-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #888;
    font-size: 16px;
    z-index: 10;
}

button {
    width: 100%;
    background: #29b9f6;
    color: white;
    border: none;
    padding: 12px;
    margin-top: 40px;
    cursor: pointer;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    transition: 0.3s ease;
}

button:hover:not(:disabled) {
    background: #246d8d;
}

button:disabled {
    background: #ccc;
    cursor: not-allowed;
}

.links-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 20px;
}

.link {
    font-size: 14px;
    color: white;
    cursor: pointer;
    text-decoration: underline;
}

.link-secondary {
    margin-top: 10px;
    font-size: 14px;
    color: white;
    cursor: pointer;
    text-decoration: underline;
}

.error-message {
    color: #e55050;
    font-size: 14px;
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
}

.loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    color: white;
}

.loader-spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #29b9f6;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin-bottom: 15px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>